// Tout le contenu de la landing vit ici : textes, listes, FAQ.
// Modifier ce fichier suffit pour changer la page, sans toucher aux composants.

export const NAV = {
  links: [
    { label: "Le coach", to: "/coach" },
    { label: "Tarifs", to: "/tarifs" },
    { label: "Jeux", to: "/games" },
  ],
  login: "Se connecter",
  start: "Commencer",
};

export const HERO = {
  eyebrow: "Coaching esport, séance par séance",
  title: "Un peu mieux, chaque jour.",
  lead: "Un coach, cinq jeux, des séances construites autour de votre objectif. Pas de programme générique : on regarde votre jeu à vous.",
  ctaPlayer: { label: "Réserver une séance", to: "/coach" },
  ctaCoach: { label: "Voir les tarifs", to: "/tarifs" },
  note: "Sans abonnement. De 56 à 200 € la séance, selon la durée et le contenu.",
  // Composition statique à droite du hero : reprend les tuiles du tableau de bord.
  visual: {
    stats: [
      { label: "Rang actuel", value: "Diamant II", delta: "+2 divisions ce mois" },
      { label: "Taux de victoire", value: "58 %", delta: "+6 pts sur 30 jours" },
      { label: "Séances suivies", value: "12", delta: "3 coachs différents" },
    ],
    bars: [22, 30, 26, 38, 41, 37, 52, 58, 61, 66, 64, 72],
    next: { title: "Prochaine séance", coach: "Revue de VOD avec Nael", when: "Jeudi · 19:00" },
  },
};

export const PATHS = [
  {
    key: "player",
    eyebrow: "Progresser",
    title: "Un regard extérieur sur votre jeu.",
    points: [
      "Vos parties analysées, pas des conseils génériques.",
      "Un objectif par séance, des consignes applicables seul ensuite.",
      "De 56 à 200 € selon la durée et le module choisi.",
    ],
    cta: { label: "Voir la méthode", to: "/coach", testid: "landing-cta-player" },
  },
  {
    key: "coach",
    eyebrow: "Préparer une compétition",
    title: "Règlements, formats, schémas de travail.",
    points: [
      "Formation à la réglementation des tournois que vous visez.",
      "Développement stratégique et patterns de travail répétables.",
      "Pour un joueur seul comme pour une équipe.",
    ],
    cta: { label: "Voir les tarifs", to: "/tarifs", testid: "landing-cta-coach" },
  },
];

export const STEPS = {
  eyebrow: "Comment ça marche",
  title: "Trois étapes, rien de plus.",
  items: [
    { n: "01", title: "Choisissez un coach", text: "Filtrez par jeu, rôle, rang et budget. Lisez les avis, regardez les disponibilités." },
    { n: "02", title: "Réservez une séance", text: "Un créneau, un objectif précis. Le paiement est sécurisé et libéré après la séance." },
    { n: "03", title: "Progressez, puis recommencez", text: "Chaque séance laisse des notes et des objectifs. Vous voyez votre courbe monter." },
  ],
};

export const GAMES = {
  eyebrow: "Jeux couverts",
  title: "Là où vous jouez.",
  list: ["League of Legends", "Counter-Strike 2", "Call of Duty", "Fortnite", "EA FC"],
  more: { label: "Tous les jeux", to: "/games" },
};

export const COACH_ARGS = {
  eyebrow: "Compétition",
  title: "Se préparer sérieusement.",
  lead: "Jouer mieux ne suffit pas en tournoi : il faut connaître le règlement, le format, et avoir des schémas de travail qui tiennent sous pression.",
  items: [
    { title: "Réglementation", text: "Format du tournoi, règles d'arbitrage, conditions de disqualification. Ce qui coûte des matchs quand on l'ignore." },
    { title: "Développement stratégique", text: "Des schémas de jeu construits pour votre équipe, pas copiés d'une autre." },
    { title: "Patterns de travail", text: "Des routines d'entraînement répétables entre deux séances, qui tiennent dans une semaine chargée." },
  ],
  cta: { label: "Voir les tarifs", to: "/tarifs" },
};

// Témoignages : contenu éditable. Remplacez-les par de vrais retours dès que possible.
// Le service vient d'ouvrir : nous n'avons pas encore de retours clients.
// Plutôt que d'en inventer, cette section dit ce à quoi nous nous engageons.
export const PROMISES = {
  eyebrow: "Nos engagements",
  title: "Ce sur quoi vous pouvez nous juger.",
  lead: "Perform vient d'ouvrir. Nous n'avons donc ni témoignages ni logos à afficher, et nous préférons vous dire à quoi nous tenir.",
  items: [
    { icon: "Users", title: "Un interlocuteur unique", text: "Le même coach d'une séance à l'autre. Il connaît déjà votre jeu, vos erreurs récurrentes et votre objectif." },
    { icon: "Target", title: "Aucun engagement caché", text: "Pas d'abonnement, pas de reconduction automatique. Vous payez la séance, un point c'est tout." },
    { icon: "ShieldCheck", title: "Une sécurité documentée", text: "Notre Trust Center liste ce qui est en place et ce qui manque encore. Y compris ce qui nous dessert." },
  ],
  cta: { label: "Voir le Trust Center", to: "/trust-center" },
};

export const FAQ = {
  eyebrow: "Questions fréquentes",
  title: "Avant de commencer.",
  items: [
    { q: "Combien coûte une séance ?", a: "De 56 à 200 €. Le tarif part d'une base de 56 € pour une heure, et varie selon quatre critères : la durée, le module d'entraînement (standard ou personnalisé), le type de jeu (les FPS demandent une analyse image par image) et la préparation à la compétition. Le détail de chaque écart est publié sur la page Tarifs." },
    { q: "Pourquoi un seul coach ?", a: "Parce qu'un interlocuteur unique connaît déjà votre jeu, vos erreurs et votre objectif d'une séance à l'autre. Cinq jeux suivis sérieusement valent mieux que vingt survolés." },
    { q: "Que se passe-t-il si une séance est annulée ?", a: "Annulation gratuite jusqu'à 24 heures avant. Si l'annulation vient du coach, vous êtes intégralement remboursé, quel que soit le délai." },
    { q: "Comment se déroule une séance ?", a: "En direct, avec partage d'écran, ou sur une partie enregistrée que vous déposez à l'avance. Vous repartez avec deux ou trois consignes écrites, applicables seul jusqu'à la fois suivante." },
    { q: "Y a-t-il un abonnement ?", a: "Non. Vous payez la séance que vous réservez, rien d'autre. Aucune reconduction automatique, aucun frais caché." },
  ],
};

export const FINAL_CTA = {
  title: "Votre prochaine séance commence ici.",
  lead: "Créez votre compte en une minute. Vous choisirez votre coach ensuite.",
  cta: { label: "Créer mon compte", to: "/auth", testid: "landing-final-cta" },
  secondary: { label: "Voir les tarifs", to: "/tarifs" },
};

export const FOOTER = {
  tagline: "Un peu mieux, chaque jour.",
  columns: [
    { title: "Joueurs", links: [{ label: "Le coach", to: "/coach" }, { label: "Jeux", to: "/games" }, { label: "Événements", to: "/events" }, { label: "Guides", to: "/guides" }] },
    { title: "Coaching", links: [{ label: "Le coach", to: "/coach" }, { label: "Tarifs", to: "/tarifs" }] },
    { title: "Compte", links: [{ label: "Se connecter", to: "/auth" }, { label: "Créer un compte", to: "/auth" }] },
  ],
};
